export var MooringArrivalLineTypeContent;
(function (MooringArrivalLineTypeContent) {
    MooringArrivalLineTypeContent["AllFast"] = "all fast";
    MooringArrivalLineTypeContent["FirstLineAshore"] = "first line ashore";
})(MooringArrivalLineTypeContent || (MooringArrivalLineTypeContent = {}));
export var MooringArrivalLineContent;
(function (MooringArrivalLineContent) {
    MooringArrivalLineContent["ForwardSpring"] = "forward spring";
    MooringArrivalLineContent["AftSpring"] = "aft spring";
    MooringArrivalLineContent["HeadLine"] = "head line";
    MooringArrivalLineContent["SternLine"] = "stern line";
})(MooringArrivalLineContent || (MooringArrivalLineContent = {}));
export var MooringArrivalLineArrangementContent;
(function (MooringArrivalLineArrangementContent) {
    MooringArrivalLineArrangementContent["TwoPlusOne"] = "2+1 fwd & aft";
    MooringArrivalLineArrangementContent["ThreePlusTwo"] = "3+2 fwd & aft";
    MooringArrivalLineArrangementContent["FourPlusTwo"] = "4+2 fwd & aft";
    MooringArrivalLineArrangementContent["FourPlusThree"] = "4+3 fwd & aft";
    MooringArrivalLineArrangementContent["FivePlusTwo"] = "5+2 fwd & aft";
})(MooringArrivalLineArrangementContent || (MooringArrivalLineArrangementContent = {}));
export const mooringArrivalLineTypeContentOptions = [
    { value: MooringArrivalLineTypeContent.AllFast, text: MooringArrivalLineTypeContent.AllFast },
    { value: MooringArrivalLineTypeContent.FirstLineAshore, text: MooringArrivalLineTypeContent.FirstLineAshore },
];
//# sourceMappingURL=MooringLineHandlingContents.js.map